import { z } from 'zod'
import { CorporateAccountStatus } from '@library/enums'
import { commonDataSchema } from './common-data'
import { corporateAccountCommonSchema } from './corporate-account-common'
import {
  CorporateAccountPermissions,
  corporateAccountPermissionsSchema
} from './corporate-account-permissions'
import { enumWithEmpty } from './enum-with-empty'

/** 企業帳號 Schema */
export const corporateAccountSchema = corporateAccountCommonSchema
  .merge(corporateAccountPermissionsSchema)
  .merge(commonDataSchema)
  .merge(
    z.object({
      /** 企業帳號ID */
      account: z.string(),
      /** 主帳號 */
      primary: z.boolean(),
      /** 啟用狀態 */
      status: enumWithEmpty(CorporateAccountStatus),
      /** 權限 */
      permission: z.boolean()
    })
  )

/** 企業帳號 */
export interface CorporateAccount
  extends z.infer<typeof corporateAccountSchema> {}

export class CorporateAccount {
  constructor() {
    return {
      account: '',
      primary: false,
      status: '',
      lang: '',
      title: '',
      firstName: '',
      lastName: '',
      name: '',
      countryCode: '',
      phoneNo: '',
      email: '',
      permission: false,
      ...new CorporateAccountPermissions()
    }
  }
}
